/** A refused write, read ONCE for both draft lanes (SA-404 custom-row drafts,
 * SA-416 Configure overlays — one contract). 409 `draft_base_moved` = the
 * version this session was based on moved under it; 409
 * `workflow_published_since` (SA-1410) = the live version moved since the
 * session opened; any other 409 = the stored draft is not the one this
 * session knows (`draft_stale`). Null = not a conflict. */
import { ApiError } from '@/services/apiClient'

export type WriteConflict = 'stale' | 'base_moved' | 'published_since'

export function writeConflict(error: unknown): WriteConflict | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null
  const detail = error.detail as { detail?: unknown } | null
  const code = detail && typeof detail === 'object' ? detail.detail : undefined
  if (code === 'draft_base_moved') return 'base_moved'
  if (code === 'workflow_published_since') return 'published_since'
  return 'stale'
}
